import React from "react";
import Card from "../Card/Card";
import "./Skills.css";
import { theamContex } from "../../Context";
import { useContext } from "react";

function Skills() {
  const theme = useContext(theamContex);
  const darkMode = theme.state.darkMode;
  return (
    <div
      id="Skills"
      className="skills"
      style={{
        background: darkMode ? "black" : "",
        color: darkMode ? "white" : "",
      }}
    >
      <div className="skill-name">
        <h1>
          My Technical <span>Skills</span>
        </h1>
      </div>
      <div className="cards">
        <div>
          <Card
            emoji={<i class="fa-solid fa-code"></i>}
            heading={"HTML"}
            bar={"90%"}
            class={"html"}
          />
        </div>
        <div>
          <Card
            emoji={<i class="fa-brands fa-css3-alt"></i>}
            heading={"CSS"}
            bar={"80%"}
            class={"css"}
          />
        </div>
        <div>
          <Card
            emoji={<i class="fa-brands fa-square-js"></i>}
            heading={"JavaScript"}
            bar={"70%"}
            class={"js"}
          />
        </div>
        <div>
          <Card
            emoji={<i class="fa-brands fa-react"></i>}
            heading={"React"}
            bar={"65%"}
            class={"react"}
          />
        </div>
        <div>
          <Card
            emoji={<i class="fa-brands fa-react"></i>}
            heading={"Java"}
            bar={"75%"}
            class={"react"}
          />
        </div>
      </div>
      <div className="blur-1"></div>
    </div>
  );
}

export default Skills;
